import {useTranslation} from "react-i18next";

function Myreg() {
    const { t } = useTranslation();

    return (
      <div style={{display: "flex", alignItems: "center", width: "100%", height: "100%"}}>
        <div style={{verticalAlign: "middle", textAlign: "center", width: "100%", fontSize: "48px"}}
             dangerouslySetInnerHTML={{__html: t("myreg", {interpolation: {escapeValue: false}})}} />
      </div>
    );
}

export default Myreg
